module.exports = __webpack_public_path__ + "static/media/Layoff.21104821.svg";